export default "__VITE_ASSET__BoP96yof__"